module.exports = __webpack_public_path__ + "static/RootSans-6Italic-92f5bc7aeb2727e8b8e78fc0156ac506.woff2";